import { QRCodeSVG } from "qrcode.react"
export default QRCodeSVG